import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { CookiesProvider } from "react-cookie";
import App from './App';
import theme from './theme';
import "./services/i18n";
import './index.css';

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CookiesProvider>
      <CssBaseline />
      <Suspense fallback="Loading...">
        <App />
      </Suspense>
    </CookiesProvider>
  </ThemeProvider>,
  document.querySelector('#root'),
);
